import React, { useEffect, useState } from "react";
import { getGtmEventClickData } from "./../../utilities/client/analytics";
import routeNames from "./../../utilities/server/routeNames";
import { SVGIcon } from "./../Icons";
import { useIsScrolled } from "../../utilities/client/use-is-scrolled-pure-js";
import ButtonGridLayout from "../ButtonGridLayout";
import Search from "../Search";
import logo from "../../../public/images/logo2x.avif";
import classnames from 'classnames';

import {
  StyledDesktopHeader,
  StyledTagline,
  StyledDesktopLogo,
  StyledDesktopNav,
  StyledDesktopNavLink,
  StyledDesktopNavItem,
  StyledDesktopNavWrapper,
  StyledWidthCtn,
  StyledMobileBelt,
  StyledMobileHeader,
  StyledHamburger,
  StyledMobileMenu,
  StyledMobileNav,
  StyledMobileNavLink,
  StyledMobileNavItem,
  StyledCloseMenu,
  StyledMobileLogo,
  StyledMobileLogoAmp,
  StyledMobileLogoWrapper,
  Spacer,
  StyledDesktopSecondaryNav,
  SpacerSecondary,
  StyledDesktopSecondaryNavItem,
  StyledDesktopSecondaryNavLink,
  StyledTaglineMobile,
  StyledMobileNavLinkSecondary,
  StyledMobileSearchItem,
  StyledDesktopSearchItem
} from "./styles";

export const HeaderHome = ({
  clientContext = null,
  context = null,
  childCategories = null,
  isHomepage = false,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const [isSearchHidden, setIsSearchHidden] = useState(true);
  const [shouldMountSearch, setShouldMountSearch] = useState(false);

  let { isMobile, isTablet } = clientContext;
  let { isAmp } = context;
  let { settings } = context.data;
  let tagline = settings?.strings?.home?.tagline;
  let isScrolled = useIsScrolled();
  let isSticky = false;
  let isSecondarySticky = false;
  let showSecondaryNav = false;

  if (childCategories?.length > 0 && isHomepage) {
    showSecondaryNav = true;
    isSecondarySticky = isScrolled?.y >= 136;
  }
  else if (childCategories?.length > 0 && !isHomepage) {
    showSecondaryNav = true;
    isSecondarySticky = isScrolled?.y >= 80;
  }
  else if (isHomepage) {
    isSticky = isScrolled?.y >= 40;
  }
  else {
    isSticky = isScrolled?.y >= 0;
  }

  useEffect(() => {
    if (!shouldMountSearch && !isSearchHidden && !isAmp) {
      setShouldMountSearch(true);
    }
  }, [isSearchHidden]);

  return (
    <>
      {isMobile || isTablet ? (
        <>
          <StyledMobileHeader isHomepage={isHomepage}>
            {!clientContext?.isInMemoriamHost && tagline && isHomepage && (
              <StyledTaglineMobile>{tagline}</StyledTaglineMobile>
            )}
            <StyledMobileBelt isInMemoriamHost={clientContext?.isInMemoriamHost}>
              {!clientContext?.isInMemoriamHost && (
                <StyledHamburger onClick={() => setShowMenu(!showMenu)}>
                  <SVGIcon iconName="hamburger" />
                </StyledHamburger>
              )}
              {isAmp === false ? (
                <StyledMobileLogoWrapper>
                  <StyledMobileLogo
                    to={routeNames.home}
                    onClick={(e) => {
                      e.preventDefault();
                      getGtmEventClickData(e.currentTarget);
                    }}
                    data-track-hit-type="event"
                    data-track-event-category="Navbar"
                    data-track-event-action="click"
                    data-track-event-label={"/"}
                    data-track-event-value={3}
                    data-track-redirect
                    activeClassName="active"
                  >
                    <img src={logo} alt=""/>
                  </StyledMobileLogo>
                </StyledMobileLogoWrapper>
              ) : (
                <StyledMobileLogoWrapper>
                  <StyledMobileLogoAmp
                    href={routeNames.home}
                    onClick={(e) => {
                      e.preventDefault();
                      getGtmEventClickData(e.currentTarget);
                    }}
                    data-track-hit-type="event"
                    data-track-event-category="Navbar"
                    data-track-event-action="click"
                    data-track-event-label={"/"}
                    data-track-event-value={3}
                    data-track-redirect
                    activeClassName="active"
                  >
                    <img src={logo} alt=""/>
                  </StyledMobileLogoAmp>
                </StyledMobileLogoWrapper>
              )}
              {!clientContext?.isInMemoriamHost && (
                <StyledMobileSearchItem>
                  <button type="button" onClick={() => setIsSearchHidden(false)}>
                    <SVGIcon iconName="search" />
                  </button>
                </StyledMobileSearchItem>
              )}
            </StyledMobileBelt>
          </StyledMobileHeader>

          {showMenu && (
            <StyledMobileMenu>
              <StyledCloseMenu>
                <a
                  to={routeNames.home}
                  onClick={(e) => {
                    e.preventDefault();
                    getGtmEventClickData(e.currentTarget);
                  }}
                  data-track-hit-type="event"
                  data-track-event-category="Navbar"
                  data-track-event-action="click"
                  data-track-event-label={"/"}
                  data-track-event-value={3}
                  data-track-redirect
                  activeClassName="active"
                >
                  <img src={logo} alt=""/>
                </a>
                <div onClick={() => setShowMenu(!showMenu)}>
                  <SVGIcon
                    styles={{ height: "min-height" }}
                    iconName="closeIcon"
                  />
                </div>
              </StyledCloseMenu>

              <StyledMobileNav isMobile={isMobile}>
                {settings.nav.links.map((link) => (
                  <StyledMobileNavItem
                    key={`nav-${link.label.toLowerCase()}`}
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid #4c4c4f",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                      }}
                    >
                      <StyledMobileNavLink
                        to={link.path}
                        onClick={(e) => {
                          e.preventDefault();
                          getGtmEventClickData(e.currentTarget);
                        }}
                        data-track-hit-type="event"
                        data-track-event-category="Navbar"
                        data-track-event-action="click"
                        data-track-event-label={link.path}
                        data-track-event-value={3}
                        data-track-redirect
                        activeClassName="active"
                      >
                        {link.label}
                      </StyledMobileNavLink>
                    </div>
                    {link.children !== undefined &&
                      link.children.length > 0 &&
                      link.children.map((child) => (
                        <StyledMobileNavItem
                          key={`nav-${child.label.toLowerCase()}`}
                          style={{
                            borderBottom: "1px solid #4c4c4f",
                            paddingTop: "12px",
                            paddingBottom: "12px",
                          }}
                        >
                          <StyledMobileNavLinkSecondary
                            to={child.path}
                            onClick={(e) => {
                              e.preventDefault();
                              getGtmEventClickData(e.currentTarget);
                            }}
                            data-track-hit-type="event"
                            data-track-event-category="Navbar"
                            data-track-event-action="click"
                            data-track-event-label={child.path}
                            data-track-event-value={3}
                            data-track-redirect
                            activeClassName="active"
                          >
                            {child.label}
                          </StyledMobileNavLinkSecondary>
                        </StyledMobileNavItem>
                      ))}
                  </StyledMobileNavItem>
                ))}
              </StyledMobileNav>
            </StyledMobileMenu>
          )}
        </>
      ) : (
        <>
          <StyledDesktopHeader>
            {!clientContext?.isInMemoriamHost && tagline && isHomepage && <StyledTagline>{tagline}</StyledTagline>}
            <StyledDesktopNavWrapper
              isSticky={isSticky}
              showSecondaryNav={showSecondaryNav}
            >
              <StyledWidthCtn isInMemoriamHost={clientContext?.isInMemoriamHost}>
                <StyledDesktopLogo
                  to={routeNames.home}
                  onClick={(e) => {
                    e.preventDefault();
                    getGtmEventClickData(e.currentTarget);
                  }}
                  data-track-hit-type="event"
                  data-track-event-category="Navbar"
                  data-track-event-action="click"
                  data-track-event-label={"/"}
                  data-track-event-value={3}
                  data-track-redirect
                >
                  <img src={logo} alt="" />
                </StyledDesktopLogo>
                {!clientContext?.isInMemoriamHost && (
                  <StyledDesktopNav>
                    {settings.nav.links.map((link) => (
                      <StyledDesktopNavItem
                        key={`nav-${link.label.toLowerCase()}`}
                      >
                        <StyledDesktopNavLink
                          to={link.path}
                          onClick={(e) => {
                            e.preventDefault();
                            getGtmEventClickData(e.currentTarget);
                          }}
                          data-track-hit-type="event"
                          data-track-event-category="Navbar"
                          data-track-event-action="click"
                          data-track-event-label={link.path}
                          data-track-event-value={3}
                          data-track-redirect
                        >
                          {link.label}
                        </StyledDesktopNavLink>
                      </StyledDesktopNavItem>
                    ))}
                  </StyledDesktopNav>
                )}
                {!clientContext?.isInMemoriamHost && (
                  <StyledDesktopSearchItem>
                    <button type="button" onClick={() => setIsSearchHidden(false)}>
                      <SVGIcon iconName="search" /> Search
                    </button>
                  </StyledDesktopSearchItem>
                )}
                {!clientContext?.isInMemoriamHost && (
                  <ButtonGridLayout label="Subscribe" path="/subscribe" />
                )}
              </StyledWidthCtn>
            </StyledDesktopNavWrapper>
          </StyledDesktopHeader>

          <Spacer isSticky={isSticky} />

          {showSecondaryNav && (
            <>
              <StyledDesktopSecondaryNav isSecondarySticky={isSecondarySticky}>
                {childCategories.map((link) => (
                  <StyledDesktopSecondaryNavItem
                    key={`nav-${link.label.toLowerCase()}`}
                  >
                    <StyledDesktopSecondaryNavLink
                      to={link.path}
                      onClick={(e) => {
                        e.preventDefault();
                        getGtmEventClickData(e.currentTarget);
                      }}
                      data-track-hit-type="event"
                      data-track-event-category="Navbar"
                      data-track-event-action="click"
                      data-track-event-label={link.path}
                      data-track-event-value={3}
                      data-track-redirect
                    >
                      {link.label}
                    </StyledDesktopSecondaryNavLink>
                  </StyledDesktopSecondaryNavItem>
                ))}
              </StyledDesktopSecondaryNav>
              <SpacerSecondary isSecondarySticky={isSecondarySticky} />
            </>
          )}
        </>
      )}

      {shouldMountSearch && (
        <Search
          context={context}
          clientContext={clientContext}
          hidden={isSearchHidden}
          setHidden={setIsSearchHidden}
        />
      )}
    </>
  );
};

export default HeaderHome;
